<template>
    <v-content>
        <layout-page-info :title="title">
            <div v-html="content"></div>
            <template slot="btn">
                <v-btn @click="onSubmit" color="success">Начать тестирование</v-btn>
            </template>
        </layout-page-info>
    </v-content>
</template>

<script>
    import {mapState} from 'vuex'
    import LayoutPageInfo from '@/components/layouts/page-info'
    import config from './config.json'

    export default {
        components: {
            LayoutPageInfo
        },
        computed: {
            ...mapState('auth', ['role']),
            config () {
                return this.isEmployer ? config.employer : config.other
            },
            title () {
                return this.config.title
            },
            content () {
                return this.config.content
            },
            isEmployer () {
                return this.role === 'employer'
            }
        },
        methods: {
            onSubmit () {
                this.$store.dispatch('session/push', 'profile')
            }
        }
    }
</script>
